import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const helperApi = createApi({
  reducerPath: "helperApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/helper/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getImageFile: builder.query({
      query: (url) => ({
        url: `getImageFile/${url}`,
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "Image", id: "List" },
        ...(result ?? []).map((Image) => ({ type: "Image", id: Image.id })),
      ],
    }),
  }),
});

export const { useGetImageFileQuery } = helperApi;
